import { InstagramHandlesActionTypes } from '@store/campaigns'

export const downloadInstagramHandles = (campaignId: number, fileName: string) => ({
  payload: { campaignId, fileName },
  type: InstagramHandlesActionTypes.DOWNLOAD_CSV,
})
